module.exports = __webpack_public_path__ + "img/alert-triangle.d88bf755.svg";